import { ConstantPool } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
declare var $:any;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  standalone: true,
  imports: [TranslateModule]
})
export class FooterComponent implements OnInit {

  lanName:any='';

  constructor(public translateService: TranslateService) { 
   }

  ngOnInit(): void {

    
    // translate.setDefaultLang(browserLang); 

    // this.lanName = localStorage.removeItem('net_lang_new');
    this.lanName = localStorage.getItem('net_lang_new');

    // console.log(this.lanName);
    // if(this.lanName == 'en')
    // {
    //   $('#langName').html('English');
    // }
    // else if(this.lanName == 'jp'){
    //   $('#langName').html('日本語');
    // }
    // else {
    //   $('#langName').html(this.translateService.instant('language'));
    // }

  }

  useLanguage(language: string) {
    console.log(language);
    if(language == 'en')
    {
      $('#langName').html('English');
    }else if(language == 'jp'){
      $('#langName').html('日本語');
    }
    localStorage.setItem('net_lang_new',language);
    this.translateService.use(language);
    location.reload(); 
  }

}
